export default "__VITE_ASSET__DYrvXwed__"